export default "__VITE_ASSET__Ct8nAVnm__"